/**
 *
 *  PhoneCodeInput
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 14/06/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { MouseEvent, ChangeEvent } from 'react';
import clsx from 'clsx';
import { Theme } from '@material-ui/core';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

// Utils
import { isAndroidDevice, isMac, isIosDevice } from '../../utils';

import { makeStyles } from '@material-ui/core/styles';
// import { useLocation, useHistory } from 'react-router-dom';

import usaFlag from './usa-flag.png';
import usaFlag2x from './usa-flag@2x.png';
import usaFlag3x from './usa-flag@3x.png';

const useStyles = makeStyles((theme: Theme) => ({
  // googleButton: {
  //   background: 'white',
  //   color: 'rgb(0, 94, 166)',
  //   'border-radius': '4px',
  //   border: '2px solid rgb(2, 122, 197)',
  //   margin: '1.8em 0 0.7em',
  //   'text-transform': 'none',
  //   'box-shadow': 'none',
  //   padding: '0.3em 1em',
  //   [theme.breakpoints.down('sm')]: {
  //     width: '100%',
  //   },
  //   '&:hover': {
  //     background: 'white',
  //     'box-shadow': 'none',
  //   },
  // },
  // errorMessage: {
  //   color: 'red',
  //   display: 'flex',
  //   'align-items': 'center',
  //   margin: '1em 0 0.2em',
  //   '& svg': {
  //     'margin-right': '0.4em',
  //   },
  // },
  // container: {
  //   'margin-top': '80px', //'2.5em',
  //   padding: '24px',
  //   // height: '100%',
  //   // 'margin-bottom': '2.5em',
  // },
  // partnerLabelContainer: {
  //   position: 'relative',
  //   display: 'flex',
  //   'align-items': 'center',
  //   'justify-content': 'center',
  //   'margin-bottom': '52px',
  //   // 'background-image': Partner,
  //   'background-size': '100%',
  //   'background-repeat': 'no-repeat',
  //   width: '107px',
  //   height: '36px',
  //   [theme.breakpoints.down('sm')]: {
  //     // width: '100%',
  //     // height: '100px',
  //     // backgroundPositionY: '140px',
  //   },
  // },
  // trubeLogo: {
  //   // position: 'absolute',
  //   // top: 0,
  //   // left: '0',
  //   'margin-bottom': '10px',
  // },
  // gutterBottom: {
  //   'margin-bottom': '1em',
  // },
  // greyColor: {
  //   color: theme.grey,
  // },
  // passwordContainer: {
  //   // 'min-height': '120px',
  //   'margin-bottom': '24px',
  // },
  phoneCodeInput: {
    position: 'relative',
    // 'margin-right': '8px',
    // 'align-items': 'center',
    // cursor: 'pointer',
    // 'flex-shrink': 0,
    // display: 'flex',
    // 'margin-right': '8px',
    // position: 'relative',
  },
  flagContainer: {
    position: 'absolute',
    width: '32px',
    top: '16px',
    left: '16px',
    'user-select': 'none',
    'flex-shrink': 0,
    'font-size': '28px',
    // "tbk-absolute tbk-left-2 tbk-select-none tbk-text-3xl"
  },
  // inputTextField: {
  //   // 'padding-left': '56px',
  //   // 'padding-right': '8px',
  //   // cursor: 'pointer',
  //   // width: '7.25rem',
  //   // height: '64px',
  //   // 'margin-bottom': 0,
  //   // 'border-color': 'rgb(224 234 243)',
  //   // 'border-radius': '0.5rem',
  //   // 'border-style': 'solid',
  //   // 'border-width': '1px',
  // },
  // submitButton: {
  //   // className="tb-button tbk-mb-2 tbk-w-full"
  //   [theme.breakpoints.down('sm')]: {
  //     width: '100%',
  //   },
  // },
  // linkLikeButton: {
  //   'text-decoration': 'underline',
  // },

  // closeBackgroundSelection: {
  //   cursor: 'pointer',
  //   display: 'flex',
  //   background: 'transparent',
  //   border: '0',
  //   padding: '0',
  // },
}));

interface PhoneCodeInputProps {
  className?: any;
  inputClassName?: string;
  countryFlag?: any;
  countryShortName?: any;
  phoneCode?: any;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  onChange?: (evt: ChangeEvent<HTMLInputElement>) => void;
}

type Ref = HTMLDivElement;

export const PhoneCodeInput = React.forwardRef<Ref, PhoneCodeInputProps>(
  ({ className, inputClassName, countryFlag, countryShortName, phoneCode, onClick, onChange }, outerRef) => {
    const classes = useStyles();

    return (
      <div
        ref={outerRef}
        className={clsx(className, classes.phoneCodeInput)}
        // className={`${className} tbk-relative tbk-flex tbk-shrink-0 tbk-cursor-pointer tbk-items-center`}
        onClick={onClick}
      >
        <Grid container>
          <TextField
            type="text"
            inputProps={{
              style: {
                padding: '18px 8px 18px 56px',
                width: '32px',
                // height: "64px",
                fontSize: phoneCode && phoneCode.length > 2 ? '17px' : '22px',
              },
            }}
            InputProps={{ disableUnderline: true }}
            // className={classes.inputTextField}
            // className={`${inputClassName} tbk-input-field tbk-mb-0 tbk-h-7 ${
            //   phoneCode && phoneCode.length > 3
            //     ? "tbk-text-h3-subtitle"
            //     : "tbk-text-title-medium"
            // } tbk-w-29 tbk-cursor-pointer tbk-pl-6 tbk-pr-1`}
            value={phoneCode}
            onChange={onChange}
            // readOnly
          />
          <span className={classes.flagContainer}>
            {countryFlag}
            {/*{false && (isAndroidDevice || isMac || isIosDevice) ? (
              countryFlag
            ) : (
              <img src={usaFlag} srcSet={`${usaFlag} 1x, ${usaFlag2x} 2x`} className="" alt={countryShortName} />
            )}*/}
          </span>
        </Grid>
      </div>
    );
  }
);

export default PhoneCodeInput;
